import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/messaging";
import {getFirebaseToken} from "../commons/index";

const getFirebase = (token, count = 0) => {
  const firebaseConfig = {
    apiKey: `${process.env.FIREBASE_API_KEY}`,
    databaseURL: `${process.env.FIREBASE_DATABASE_URL}`,
    projectId: `${process.env.FIREBASE_PROJECT_ID}`,
    appId: `${process.env.FIREBASE_APP_ID}`,
    messagingSenderId: `${process.env.MESSAGING_SENDER_ID}`,
    storageBucket: `${process.env.STORAGE_BUCKET}`,
    authDomain: `${process.env.FIREBASE_AUTH_DOMAIN}`,
  };
  if (firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
    firebase
      .auth()
      .signInWithCustomToken(token)
      .then((response) => {})
      .catch((error) => {});
    //firebase.analytics();
  }
  // return firebase;
  return firebase
    .auth()
    .signInWithCustomToken(token)
    .then((response) => {
      return firebase;
    })
    .catch(function (error) {
      // Handle Errors here.
      if (error.code === "auth/invalid-custom-token") {
        if (count < 2) {
          return getFirebaseToken().then((res) => {
            return getFirebase(res.token, count + 1);
          });
        } else {
          window.location && window.location.reload();
        }
      }
    });
};

const publicPath = process.env.NODE_ENV === "development" ? "/public/" : "";

const getMessaging = async (firebaseToken) => {
  return getFirebase(firebaseToken).then((firebase) => {
    const messaging = firebase.messaging();

    const SW_URL = `${publicPath}firebase-messaging-sw.js`;

    return navigator.serviceWorker.register(SW_URL).then((registration) => {
      console.log("Worker registration successful", registration.scope);
      return messaging
        .getToken({serviceWorkerRegistration: registration})
        .then((token) => {
          return {messaging, firebase, token};
        })
        .catch((err) => {
          console.error("err: ", err);
        });
    });
  });
};

export {getFirebase, getMessaging};
